import { Component, OnInit } from "@angular/core";
import { FileUploader, FileItem, ParsedResponseHeaders } from "ng2-file-upload";
import Swal from "sweetalert2";
import { Globals } from "../../globals";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-carga-masiva",
  templateUrl: "./carga-masiva.component.html",
  styleUrls: ["./carga-masiva.component.css"]
})
export class CargaMasivaComponent implements OnInit {
  HabilitarBoton = false;
  listarErrores = false;
  origenDatos = [];
  displayedColumns: string[] = ["error"];

  etiquetas = {
    realizarCarga: {
      titulo: "Carga de Usuarios?",
      texto: "A continuación se procederán a cargar los usuarios que se encuentren en el archivo de texto plano .csv",
      tipo: "warning",
      botonConfirmar: "Si, cargar usuarios!",
      botonCancelar: "No, cargar"
    },
    enviarEncuesta: {
      titulo: "Enviar notificación encuestas?",
      tipo: "warning",
      botonConfirmar: "Si",
      botonCancelar: "No, Enviar"
    },
    confirmacion: { titulo: "Cargados!", texto: "Todos los usuarios se han cargado exitosamente en la base de datos." },
    cancelacion: { titulo: "Cancelado", texto: "Se a cancelado la carga de los usuarios" },
    cancelacionEncuesta: { titulo: "Cancelado", texto: "Se a cancelado el envio de encuestas" },
    error: { titulo: "Ocurrio un error", texto: "No se pudieron cargar los usuarios" }
  };

  titularAlerta: string = "";

  constructor(public globals: Globals) {}

  ngOnInit() {
    this.uploader.onBeforeUploadItem = item => {
      item.withCredentials = false;
    };
    this.uploader.onSuccessItem = (item, response, status, headers) =>
      this.onSuccessItem(item, response, status, headers);
  }

  onSuccessItem(item: FileItem, response: string, status: number, headers: ParsedResponseHeaders): any {
    Swal.close();
    //////conole.log(response);
    let datos = JSON.parse(response);
    if (datos.error) {
      Swal.fire(this.etiquetas.error.titulo, this.etiquetas.error.texto, "error");
      //////conole.log(datos);
      this.origenDatos=datos.error;
      this.listarErrores =true;
    } else {
      this.procesarResultado(datos);
    }
  }

  async procesarResultado(datos) {
    //////conole.log(datos);
    if (datos.crear > 0) {
      let result = await Swal.fire({
        title: this.etiquetas.enviarEncuesta.titulo,
        text: `El archivo ha sido cargado exitosamente. Se encontraron ${Math.ceil(
          datos.crear / 2
        )} empleados nuevos. ¿Deseas enviar la encuesta de Conflictos de Interés?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.etiquetas.enviarEncuesta.botonConfirmar,
        cancelButtonText: this.etiquetas.enviarEncuesta.botonCancelar
      });
      if (result.value) {
        this.globals.contenedorVarGlobal = "encuesta";
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire(this.etiquetas.cancelacionEncuesta.titulo, this.etiquetas.cancelacionEncuesta.texto, "error");
        this.globals.contenedorVarGlobal = "buscar";
      }
    } else {
      Swal.fire(this.etiquetas.confirmacion.titulo, this.etiquetas.confirmacion.texto, "success");
      this.globals.contenedorVarGlobal = "buscar";
    }
  }

  onFileSelected() {
    this.HabilitarBoton = true;
  }

  URL = `${environment.apiUrl}/Carga`;

  public uploader: FileUploader = new FileUploader({ url: this.URL });

  async CargaExitosa() {
    let item = this.uploader.queue[0];
    //////conole.log(item);
    let result = await Swal.fire({
      title: this.etiquetas.realizarCarga.titulo,
      text: this.etiquetas.realizarCarga.texto,
      type: "warning",
      showCancelButton: true,
      confirmButtonText: this.etiquetas.realizarCarga.botonConfirmar,
      cancelButtonText: this.etiquetas.realizarCarga.botonCancelar
    });
    if (result.value) {
      Swal.fire("Cargando");
      Swal.showLoading();
      item.upload();
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      Swal.fire(this.etiquetas.cancelacion.titulo, this.etiquetas.cancelacion.texto, "error");
    }
  }
}
